document.addEventListener("DOMContentLoaded", function () {
// for home page content
  const read_more_btn_home = document.querySelector("#more_less_btn_home");
    if (read_more_btn_home) {
    read_more_btn_home.addEventListener("click", function (e) {

      e.preventDefault();
      e.stopImmediatePropagation();
      var string = this.innerText
      let more_content = document.querySelector(".site-info-wrapper");
      var substr = "Read More";
      var lesstrtxt = "Read Less"
      var newStr = string.replace(substr, "Read Less");
      var lessStr = string.replace(lesstrtxt, "Read More");
      more_content.classList.toggle('is-showen');
   if(string.includes(substr)){
     this.innerText = newStr;
   }
   else if(string.includes(lesstrtxt)){
     this.innerText = lessStr
   }
    });
    }
  // for collection page 
  const read_more_btn = document.querySelector("#more_less_btn");
  if (read_more_btn) {
    read_more_btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      let more_content = document.querySelector("#more_content_desc");
      if (more_content.style.display === "none") {
        more_content.style.display = "block";
        this.innerText = "Read less";
      } else {
        more_content.style.display = "none";
        this.innerText = "Read more";
      }
    });
  }
});

 var dateObj = new Date();

  let months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  let final_date =
    months[dateObj.getMonth()] +
    " " +
    dateObj.getDate() +
    "," +
    dateObj.getFullYear();

let readmoreTable = document.querySelectorAll("#more_content_desc .table");
if(readmoreTable){
  
for (let i = 0; i < readmoreTable.length; i++) {
  const Table = readmoreTable[i]
  const node = document.createElement("p");
  node.style.marginTop = "15px";
  const textNode = document.createTextNode(
    "The price list was updated on " + final_date
  );
  node.appendChild(textNode);
  Table.appendChild(node);
  
}

}